import React from "react";
import { Grid } from "@mui/material";
import { GoogleOAuthProvider } from "@react-oauth/google";

import AllMyTask from "./AllMyTask";
import "./GoogleLogin.scss";
import GoogleLogin from "./GoogleLogin";
import MyPlannerTasks from "./MyPlannerTasks";
import { useResponsive } from "../../../hooks/useResponsive";
import "./planner-mobile-responsive.scss";
import Loader from "../../../components/Loader";
import { DragDropContext } from "react-beautiful-dnd";
import { useMyPlannerPageState } from "../hooks/useMyPlannerPageState";

function MyPlanner() {
  const isMobile = useResponsive("down", "md");
  const {
    filter,
    filteredTasks,
    isLoadingPlannerTokenSharing,
    onTaskDragEnd,
    plannerToken,
    plannerTokenSharingEnabled,
    setFilter,
    setPlannerToken,
    token,
  } = useMyPlannerPageState();

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div
        className={`my-planner-top-container ${
          isMobile ? "planner-mobile-view" : ""
        }`}
      >
        <DragDropContext onDragEnd={onTaskDragEnd}>
          <Grid
            container
            spacing={2}
            className="my-planner-grid-container"
            mt={0}
          >
            <Grid item xs={12} md={8} className="my-planner-left">
              {plannerTokenSharingEnabled || plannerToken ? (
                <MyPlannerTasks
                  filter={filter}
                  setFilter={setFilter}
                  filteredTasks={filteredTasks}
                />
              ) : !token && !isLoadingPlannerTokenSharing ? (
                <GoogleLogin setPlannerToken={setPlannerToken} />
              ) : (
                <div className="loader-center">
                  <Loader color="black" />
                </div>
              )}
            </Grid>
            <Grid item xs={12} md={4} className="my-planner-right">
              <AllMyTask />
            </Grid>
          </Grid>
        </DragDropContext>
      </div>
    </GoogleOAuthProvider>
  );
}

export default MyPlanner;
